import React from 'react'
import { Typography } from '@mui/material'

export default ({ uischema }) => {
    return (
        <Typography
            variant={'subtitle2'}
            sx={{
                color: 'rgb(134, 132, 140)',
                margin: '5px 0 25px 0',
            }}
        >
            {' '}
            {uischema.text}{' '}
        </Typography>
    )
}
